<template>
  <div>
    <div class="text-center pt-3">
      <img
        src="@/app-assets/images/brand/pacto-logo.png"
        alt="Pacto Logo"
        style="width: 160px"
      />
    </div>

    <div class="card">
      <div class="card-body text-center">
        <div class="lottie-animation">
          <div :class="{ hidden: !loading }">
            <lottie-player
              src="https://assets4.lottiefiles.com/packages/lf20_fwykef3x.json"
              background="transparent"
              speed="1"
              style="width: 450px; height: 450px; margin: 0 auto"
              loop
              autoplay
            ></lottie-player>
          </div>

          <div :class="{ hidden: loading }">
            <div :class="{ hidden: !success }">
              <lottie-player
                src="https://assets8.lottiefiles.com/packages/lf20_rGbZEa.json"
                background="transparent"
                speed="1"
                style="width: 350px; height: 350px; margin: 0 auto"
                loop
                autoplay
              ></lottie-player>

              <h1 class="mt-2 success-h1" v-if="success">
                <strong>{{$t('Email verified successfully!')}}</strong>
              </h1>
            </div>

            <div :class="{ hidden: !error }">
              <lottie-player
                src="https://assets3.lottiefiles.com/private_files/lf30_glnkkfua.json"
                background="transparent"
                speed="1"
                style="width: 350px; height: 350px; margin: -40px auto"
                loop
                autoplay
              ></lottie-player>

              <h1 class="error-h1" v-if="error" :innerHTML="errorMessage"></h1>

              <router-link :to="{ name: 'LoginPage' }" v-if="!user">
                <button class="btn login-btn">{{$t('Login')}}</button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/app-assets/css/pages/authentication.css";
export default {
  data() {
    return {
      user: null,
      success: false,
      error: false,
      loading: true,
      errorMessage: "",
      decodedString:''
    };
  },
  methods: {
    async verifyEmail() {
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });

      const code = this.$route.query.oobCode;

      try {
        await this.$apiCall.post("/v1/auth/verify/email", {
          oobCode: code,
          email: this.decodedString,
        });

        this.success = true;

        setTimeout(() => {
          location.href = "/login";
        }, 2000);
      } catch (error) {
        this.error = true;
        this.errorMessage = `<strong>Ops!</strong> Invalid Token`;
      } finally {
        this.loading = false;
        $.unblockUI();
      }
    },
  },
  mounted() {
    $("body").removeClass(
      "vertical-layout vertical-menu-modern 2-columns navbar-sticky footer-static"
    );
    $("body").addClass(
      "vertical-layout vertical-menu-modern 1-column navbar-sticky footer-static bg-full-screen-image blank-page blank-page"
    );

    if (this.$store.state.currentUser.user) {
      this.user = this.$store.state.currentUser.user;

    } else {
      console.log("route", this.$route.query.email)
      if(this.$route.query.email){
        let emailBase64 = this.$route.query.email;
        this.decodedString = atob(emailBase64)
        console.log('decodedString',this.decodedString);
      } else {
        this.loading = false;
        this.error = true;
        this.errorMessage = `<strong>Error authenticating user<strong>`;
      }
    }
    this.verifyEmail();
  },
  beforeMount() {
    const code = this.$route.query.oobCode;

    if (!code) {
      location.href = "/";
    }
  },
};
</script>

<style scoped>
html,
body {
  overflow: hidden;
}

.card {
  width: 950px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media (max-width: 1000px) {
  .card {
    width: 95%;
  }
}

.error-h1 {
  margin-top: -40px;
  font-size: 28px;
  line-height: 1.5;
}

.success-h1 {
  font-size: 28px;
  line-height: 1.5;
}

.login-btn {
  margin-top: 25px;
  margin-bottom: 10px;
  background: #ff8300;
  color: #fff;
  border-radius: 0;
  font-size: 20px;
  padding: 15px 60px;
}

.btn:focus {
  box-shadow: none;
  outline: none;
}
</style>
